import { render, staticRenderFns } from "./PdfForms.vue?vue&type=template&id=55a66add&scoped=true&"
import script from "./PdfForms.vue?vue&type=script&lang=js&"
export * from "./PdfForms.vue?vue&type=script&lang=js&"
import style0 from "./PdfForms.vue?vue&type=style&index=0&id=55a66add&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a66add",
  null
  
)

export default component.exports